import React from "react";
import { useState, useEffect } from "react";
//Fetch
import axios from "axios";

//Bootstrap
import { Form } from "react-bootstrap";
import { useAuthContext } from "../../Hooks/useAuthContext";


export default function FloatingParishSelect({
  value,
  required,
  classes,
  onChange
}) {

    /* Variables */
    const { user } = useAuthContext();
    const [parishList, setParishList] = useState([]);
    const [pagination, setPagination] = useState({
        pageNumber: 1,
        search: value,
    });
    const [hasFocus, setHasFocus] = useState(false);

    useEffect(() => {
        if (value && value.length > 0) {
            setPagination((prev) => ({
                ...prev,
                search: value
            }));
        }
    }, [value]);

    /* Perform search when the user types in the search box */
    const handleChange = (e) => {
        console.log("handle change:", e.target.value); 
        if (e.target.value.length > 0) {
            listParishes(e.target.value);
        } else {
            setParishList([]);
        }

        setPagination((prev) => {
            return { ...prev, search: e.target.value };
        })
        if (e.target.value === "") {
            onChange("");
        }
    }

    /* Handle Select - Occurs when an entry from the list is clicked */
    const handleSelectEntry = (entry) => {
        console.log("handle select clicked:", entry);

        onChange(entry);

        setPagination(prev => ({
            ...prev,
            search: entry.parish
        }));

        

        // Hide list immediately
        //setParishList([]);

    };

    const listParishes = async (searchText) => {
        console.log("listParishes called with searchText:", searchText); 
        let pageNum = 1;

        try {
            const res = await axios.get(
                `https://${process.env.REACT_APP_IP}/api/parishdistricts?pageNumber=${pageNum}&search=${searchText}`,
                {
                    headers: { Authorization: `bearer ${user.token}` },
                }
            );
            setParishList(res.data.results);
        } catch (error) {
            console.log(error);
        } finally {}
    };

    
    

  return (
      <Form.Group className={`mb-1 ${classes} p-1`}>
          <div className="form-floating" style={{ position: "relative"} }>
          
              
              <input
                  placeholder="Parish"
                  value={pagination.search}
                  onChange={(e) => { handleChange(e) }}
                  onFocus={() => setHasFocus(true)}
                  onBlur={() => setHasFocus(false)}
                  type="text"
                  className="form-control mb-2"
              />
              <label>
                  Parish{required && <span className="text-danger">*</span>}
              </label>

              {/* List of parishes that match search */} 
              { hasFocus && (
                  <div style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      right: 0,
                      background: "white",
                      zIndex: 9999,
                      border: "1px solid #ccc",
                      maxHeight: "240px",
                      overflowY: "auto",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                      borderRadius: "4px",
                  }}>

                      {pagination.search === "" && (<div className="ps-2">Begin typing to search for parish.</div>)}


                  {parishList.length > 0
                      ? parishList.map((entry) => (
                          <div
                              key={entry.id}
                              className="listItem p-2 hoverMe innerCon mb-1"
                              onMouseDown={() => handleSelectEntry(entry)}
                          >
                              <h5>
                                  {entry.parish}, {entry.locality}
                              </h5>
                          </div>
                      ))
                      : pagination.search !== "" && hasFocus && (
                          <div className="ps-2">No matching parish found.</div>
                      )}
              
                  </div>
              )}
          </div>
      </Form.Group>
  )
}
